import React from 'react';
import { useState, useEffect,useRef } from 'react';
import Main from '../componentes/Main';
import Axios from 'axios';
import Swal from 'sweetalert2';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose, faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { faUnlink, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { traerUrl, seleccionarTextoInput, traerAbrirUrl } from '../Helpers/utilidades-globales';
import useModal from '../hooks/useModal';
import Modal from '../componentes/Modal';
import AbmIglesias from '../abms/Abm-iglesia';
import BusquedaEntesdependientes from '../componentes/BusquedaEntesdependientes';
import { Button, Spinner, Typography } from '@material-tailwind/react';
import GoBack from '../componentes/GoBack';
import { useContextoGlobal } from '../Context/contextoGlobal';
import { MagnifyingGlassCircleIcon, TrashIcon, CheckIcon } from '@heroicons/react/24/outline';
import BusquedaProvincias from '../componentes/BusquedaProvincias';
import {IconButton} from "@material-ui/core";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Alert } from "@material-tailwind/react";
import { Chip, Tabs, TabsHeader, Tab, TabsBody, TabPanel } from "@material-tailwind/react";
import ExportToExcelCredencial from '../componentes/exportExcelCredencial';
import { TabPersonalMinisterial } from './tabsObrero/TabPersonalMinisterial';
import { TabActas } from './tabsObrero/TabActas';
import { TabDatosContacto } from './tabsObrero/TabDatosContacto';
import { TabRodados } from './tabsObrero/TabRodados';
import { TabEscrituras } from './tabsObrero/TabEscrituras';
import { DashboardFinanciero } from '../Vistas/iglesias/componentes/DashboardFinanciero';
import {BalancesYdiezmos} from '../Vistas/iglesias/componentes/BalancesYdiezmos';

export default function AbmObrero({ id_obrero, finalizarAltaOcopia, esModal, id_copia, usuario, finalizarObreroSeleccionado }) {

    // estados flags 
    const [cargandoDatosTablasGenerales, setCargandoTablasGenerales] = useState(false);
    const [cargandoDatosObrero, setCargandoDatosObrero] = useState(false);
    const [grabandoDatosObrero, setGrabandoDatosObrero] = useState(false);
    const [tablasCargadas, setTablasCargadas] = useState(false)
    const [huboError, setHuboError] = useState(false)
    const [tituloAbm, setTituloAbm] = useState('');
    const [tituloCerrar, setTituloCerrar] = useState('');
    const [contadorOperaciones, setContadorOperaciones] = useState(0);
    // vectores de selección de formulario

    const [vectorDias, setVectorDias] = useState([]);
    const [vectorMeses, setVectorMeses] = useState([]);
    const [vectorAnios, setVectorAnios] = useState([]);

    // vectores de selección de otras operaciones
    const [provincias, setProvincias] = useState([]);
    const [nacionalidades, setNacionalidades] = useState([]);
    const [estadosCiviles, setEstadosCiviles] = useState([]);
    const [regiones, setRegiones] = useState([]);
    const [distritos, setDistritos] = useState([]);
    const [rangos, setRangos] = useState([]);
    const [tiposDocumentos, setTiposDocumentos] = useState([]);
    const [entes, setEntes] = useState([]);
    const [foto, setFoto] = useState(null);

    const [iglesiaSeleccionada, setIglesiaSeleccionada] = useState(null);
    const [buscarPastorUad, setBuscarPastorUad] = useState(false)

    // Variables para manejar otras operaciones

    const [contadorModificaciones, setContadorModificaciones] = useState(0);
    const [iglesias, setIglesias] = useState([]);
    const { toggle, isShowing } = useModal();
    const [foto4x4, setFoto4x4] = useState(null);
    const { esCelular } = useContextoGlobal();

    const [diezmosPersonales,setDiezmosPersonales] = useState([]); // ps 17/08/2026
    const [buscarProvincias, setBuscarProvincias] = useState(false)
    const [activeTab, setActiveTab] = useState('personal_ministerial');
    const [esActivo,setEsActivo] = useState(true)
    const [datosParaImpresion,setDatosParaImpresion] = useState({})
    // estado objeto de inicialización que inicializa los valores del abm 
    // en el alta o es cargado con los valores de la base de datos en una modificación
    // este objeto se pasa al formulario Formik para que el estado del formulario se inicialice
    // con este objeto. Luego el resto del trabajo se hace sobre el estado del formulario  
    const [objetoInicializacion, setObjetoInicializacion] = useState({
        nombre: '',
        direccion: '',
        barrio: '',
        cod_postal: '',
        localidad: '',
        id_provincia: '',
        id_distrito: '',
        email: '',
        email_tesoreria: '',
        email_secretaria: '',
        email_pastor: '',
        telefono: '',
        celular: '',
        conyuge: '',
        anio: "",
        mes: "01",
        dia: "01",
        sexo: 'M',
        pastor: false,
        maestro: false,
        evangelista: false,
        misionero: false,
        otro: false,
        externo: false,
        id_estado_civil: 0,
        oficio: '',
        desc_ministerio: '',
        nombre_pst_resp: '',
        contacto_pst_resp: '',
        nombre_igl_resp: '',
        contacto_igl_resp: '',
        id_nacionalidad: 0,
        id_region: usuario.id_region,
        id_rango: 0,
        rango: '',
        id_tipo_doc: 0,
        nro_documento: '',
        id_iglesia_dependiente: 0,
        nombre_pastor: '',
        cred_obligatoria: false,
        observaciones:'',
    })

    useEffect(() => {

        const cargarTablasGenerales = async () => {

            setCargandoTablasGenerales(true);

            try {
                const vectorResultado = await Promise.all([
                    Axios.get('/api/tablasgenerales/nacionalidades'),
                    Axios.get('/api/tablasgenerales/estadosciviles'),
                    Axios.get(usuario.sede_admin ? '/api/tablasgenerales/regiones/*' : `/api/tablasgenerales/regiones/${usuario.id_region}`),
                    Axios.get('/api/tablasgenerales/rangos'),
                    Axios.get('/api/tablasgenerales/provincias'),
                    Axios.get('/api/tablasgenerales/tiposdocumento'),
                    Axios.get(`/api/tablasgenerales/iglesiasobrero/${id_obrero ? id_obrero : 0}`),
                    Axios.get('/api/tablasgenerales/listado/entes'),
                    Axios.get(`/api/tablasgenerales/foto/${id_obrero ? id_obrero : 0}`),
                    Axios.get(`/api/tablasgenerales/ministro/mesesdiezmados/0/${id_obrero}`)  // 17/08/2026 ps agrego id_obrero por tema diezmos 
                ])


                setNacionalidades(vectorResultado[0].data);
                setEstadosCiviles(vectorResultado[1].data);
                setRegiones(vectorResultado[2].data);
                setearRangosSegunCasos(setRangos, vectorResultado[3].data, usuario, id_obrero)
                setProvincias(vectorResultado[4].data);
                setTiposDocumentos(vectorResultado[5].data);
                setIglesias(vectorResultado[6].data);
                setEntes(vectorResultado[7].data);
                cargarVectorDias(setVectorDias);
                cargarVectorMeses(setVectorMeses);
                cargarVectorAnios(setVectorAnios);
                setFoto(vectorResultado[8].data);
                setDiezmosPersonales(vectorResultado[9].data);
                setCargandoTablasGenerales(false);
                setTablasCargadas(true)
            } catch (err) {

                console.log(err)
                const mensaje_html = `${err}`

                Swal.fire({
                    html: mensaje_html,
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                })
                setHuboError(true)
                setCargandoTablasGenerales(false);

            }
        }

        cargarTablasGenerales()
    }, [id_obrero])

    useEffect(() => { // procesa los cierres de modales por boton cerrar y no por otro motivo
        if (!isShowing) {

            if (iglesiaSeleccionada) {
                setIglesiaSeleccionada(null)
            }
            if (buscarProvincias) {
                setBuscarProvincias(false)
            }
        }
    }, [isShowing])

    useEffect(() => {

        const completarDatosDelObrero = async (id) => {
            setCargandoDatosObrero(true)
            try {

                const { data } = await Axios.get(`/api/tablasgenerales/obrero/${id}`)

                if (!data?.length) {
                    const mensaje_html = `<p>No se encontraron datos para el ministro ${id}</p>`

                    Swal.fire({
                        html: mensaje_html,
                        icon: 'warning',
                        confirmButtonColor: '#3085d6',
                    })

                    setCargandoDatosObrero(false)
                    finalizarObreroSeleccionado()
                    return
                }

                const datosDelRecordset = data[0];

                const datosObrero = {
                    id_provincia: noNullNumber(datosDelRecordset.id_provincia),
                    id_distrito: noNullNumber(datosDelRecordset.id_distrito),
                    nombre: datosDelRecordset.nombre.trim(),
                    fecha: datosDelRecordset.f_nac,
                    anio: datosDelRecordset.f_nac.slice(0, 4),
                    dia: datosDelRecordset.f_nac.slice(8, 10),
                    mes: Number(datosDelRecordset.f_nac.slice(5, 7)),
                    direccion: noNull(datosDelRecordset.direccion),
                    localidad: noNull(datosDelRecordset.localidad),
                    cod_postal: noNull(datosDelRecordset.cod_postal),
                    email: noNull(datosDelRecordset.email),
                    email_tesoreria: noNull(datosDelRecordset.email_tesoreria),
                    email_secretaria: noNull(datosDelRecordset.email_secretaria),
                    // En obreros la columna del 3er email se llama email_varios en la base
                    // (en el form/payload se maneja como email_pastor, igual que en iglesias)
                    email_pastor: noNull(datosDelRecordset.email_varios ?? datosDelRecordset.email_pastor),
                    observaciones:noNull(datosDelRecordset.observaciones),
                    telefono: noNull(datosDelRecordset.telefono),
                    celular: noNull(datosDelRecordset.celular),
                    barrio: noNull(datosDelRecordset.barrio),
                    id_estado_civil: noNullNumber(datosDelRecordset.id_estado_civil),
                    id_nacionalidad: noNullNumber(datosDelRecordset.id_nacionalidad),
                    oficio: noNull(datosDelRecordset.oficio),
                    desc_ministerio: noNull(datosDelRecordset.desc_ministerio),
                    conyuge: noNull(datosDelRecordset.conyuge),
                    nombre_pst_resp: noNull(datosDelRecordset.nombre_pst_resp),
                    contacto_pst_resp: noNull(datosDelRecordset.contacto_pst_resp),
                    nombre_igl_resp: noNull(datosDelRecordset.nombre_igl_resp),
                    contacto_igl_resp: noNull(datosDelRecordset.contacto_igl_resp),
                    sexo: noNull(datosDelRecordset.sexo),
                    id_region: noNullNumber(datosDelRecordset.id_region),
                    id_rango: noNullNumber(datosDelRecordset.id_rango),
                    region: noNull(datosDelRecordset.region),
                    pastor: datosDelRecordset.pastor,
                    maestro: datosDelRecordset.maestro,
                    evangelista: datosDelRecordset.evangelista,
                    misionero: datosDelRecordset.misionero,
                    otro: datosDelRecordset.otro,
                    externo: Boolean(datosDelRecordset.externo),
                    id_tramite: datosDelRecordset?.id_tramite,
                    nro_documento: noNullNumber(datosDelRecordset.nro_documento),
                    id_tipo_doc: noNullNumber(datosDelRecordset.id_tipo_doc),
                    f_alta: noNullNumber(datosDelRecordset.f_alta),
                    cod_seguridad: noNullNumber(datosDelRecordset.cod_seguridad),
                    id_iglesia_dependiente: noNullNumber(datosDelRecordset.id_iglesia_dependiente),
                    nombre_pastor: (datosDelRecordset.id_iglesia_dependiente != null ? obtenerDescripcionPastor(entes, datosDelRecordset.id_iglesia_dependiente) : ''),
                    cred_obligatoria: datosDelRecordset.cred_obligatoria || false
                }

                //se actualiza el objeto  de inicializacion con lo que traemos de la tabla
                // se hace un merge de los datos, los que son comunes se pisan y los nuevos se agregan
                setEsActivo(datosDelRecordset.activo)

                setObjetoInicializacion({ ...objetoInicializacion, ...datosObrero })

                setDatosParaImpresion({...datosObrero,rango:rangos.filter(i=>i.id_rango==datosDelRecordset.id_rango)[0]?.nombre,iniciales:rangos.filter(i=>i.id_rango==datosDelRecordset.id_rango)[0]?.iniciales})

                if (datosDelRecordset?.foto_4x4) {
                    const fotoaux = await traerUrl(datosDelRecordset?.foto_4x4,false)
                    setFoto4x4(fotoaux)
                }

                setCargandoDatosObrero(false)
            } catch (err) {

                console.log(err)
                const mensaje_html = `${err}`
                Swal.fire({
                    html: mensaje_html,
                    icon: 'warning',
                    confirmButtonColor: '#3085d6',
                })

                setCargandoDatosObrero(false)
                setHuboError(true)
            }

        }

        if (tablasCargadas) { // este useEffect se dispara solo si ya se cargaron las tablas generales

            if (id_obrero) { //  si se recibió el nùmero de alumno por propiedad es decir si es una modificación

                setTituloAbm(`Editar el ministro #${id_obrero}`);
                setTituloCerrar('Cerrar la ficha del ministro');
                completarDatosDelObrero(id_obrero);

            }
            else { //  si no recibió el nùmero de curso por propiedad, es decir un alta
                setTituloAbm(`Crear un nuevo ministro`);
                setTituloCerrar('Cancelar');
                hacerScroll("nuevo-obrero");

                const rangoPermitidoAlta = filtrarRangoPermitidoParaAlta(usuario,rangos)
                const regionPermitidaAlta = filtrarRegionPermitidaParaAlta(regiones)
                let anioNacimientoDefaultAlta = anioNacimientoAlta();

                setObjetoInicializacion({
                    ...objetoInicializacion,
                    anio: "",
                    id_tipo_doc:tiposDocumentos.filter(i=>i.nombre.includes("DNI"))[0]?.id_tipo_doc,
                    id_rango: rangoPermitidoAlta,
                    id_region: regionPermitidaAlta
                })

                document.getElementById('abm-nombre').focus()

            }

        }

    }, [tablasCargadas, id_obrero, contadorModificaciones])

    const cerrarBusquedaPastor = (objetoModificacion) => {
        objetoModificacion.funcion(objetoModificacion.id, 0)
        objetoModificacion.funcion(objetoModificacion.nombre, '')
        setBuscarPastorUad(false)
    }

    const finalizarSeleccion = (item, objetoModificacion) => {

        objetoModificacion.funcion(objetoModificacion.id, item.id)
        objetoModificacion.funcion(objetoModificacion.nombre, item.nombre)


        if (buscarPastorUad) {
            setBuscarPastorUad(false)
        }
    }

    const escapeListaP = (e, values, objetoModificacion) => {
        if (e.keyCode === 27) {
            e.preventDefault();

            if (values.id_iglesia_dependiente == 0) {
                objetoModificacion.funcion(objetoModificacion.id, 0)
                objetoModificacion.funcion(objetoModificacion.nombre, '')
            }

            setBuscarPastorUad(false)
        }
    }

    const desvincularMinistro = (objetoModificacion) => {
        objetoModificacion.funcion(objetoModificacion.id, 0)
        objetoModificacion.funcion(objetoModificacion.nombre, '')

    }

    const eliminar = () => {
    
            Swal.fire({
                html: `<div><p class="mb-2 mt-2">¿Confirma la eliminación del ministro?</p></div>`,
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar'
            }).then(
             async resultado => {
                    if (resultado.value) {
                        try {
                            await Promise.all([Axios.delete(`/api/tablasgenerales/obrero/${id_obrero}/${usuario.nombre}`)])
                            alert('El ministro fue eliminado exitosamente')
                            finalizarAltaOcopia(true)
                        } catch (error) {
                            alert(error?.response?.data?.message || 'Se produjo un error al eliminar el ministro')
                        }
                    }
            }               
            )
    }

    const BusquedaPastor = (e, setFieldValue) => {

        if (e.target.value == "") {
            setFieldValue('id_iglesia_dependiente', 0)
        } else {
            setBuscarPastorUad(true)
        }
    }

    const grabarObrero = async (values) => {

        let resultado;
        let id_obrero_interno;
        // me veo ogligado formatear el objeto que envío para grabar porque
        // los ids deben ser numéricos ya que se validan como números pero cuando el valor
        // viene de un "value" de un select por ejemplo se convierten a string
        // entonces antes de enviar el objeto hay que formatearlo

        const objetoAgrabar = {
            nombre: values.nombre.trim(),
            anio: Number(values.anio),
            mes: Number(values.mes),
            dia: Number(values.dia),
            direccion: values.direccion.trim(),
            barrio: values.barrio.trim(),
            localidad: values.localidad.trim(),
            cod_postal: values.cod_postal.trim(),
            celular: values.celular.trim(),
            telefono: values.telefono.trim(),
            email: values.email.trim(),
            email_tesoreria: values.email_tesoreria.trim(),
            email_secretaria: values.email_secretaria.trim(),
            email_pastor: values.email_pastor.trim(),
            oficio: values.oficio.trim(),
            id_provincia: Number(values.id_provincia),
            id_estado_civil: Number(values.id_estado_civil),
            observaciones:values.observaciones,
            id_nacionalidad: Number(values.id_nacionalidad),
            id_distrito: values.id_distrito ? Number(values.id_distrito) : null,
//            id_region: Number(usuario.id_region),   // en un alta de un obrero solo dejamos que se le asigne la región del usuario logueado   
            id_region: Number(values.id_region),   // en un alta de un obrero solo dejamos que se le asigne la región del usuario logueado             
            desc_ministerio: values.desc_ministerio.trim(),
            conyuge: values.conyuge.trim(),
            nombre_pst_resp: values.nombre_pst_resp.trim(),
            contacto_pst_resp: values.contacto_pst_resp.trim(),
            nombre_igl_resp: values.nombre_igl_resp.trim(),
            contacto_igl_resp: values.contacto_igl_resp.trim(),
            sexo: values.sexo.trim(),
            pastor: values.pastor,
            maestro: values.maestro,
            evangelista: values.evangelista,
            misionero: values.misionero,
            otro: values.otro,
            externo: values.externo,
            id_rango: Number(values.id_rango),
            id_tipo_doc: Number(values.id_tipo_doc),
            id_usuario: usuario.id_usuario,
            nro_documento: values.nro_documento != "" ? Number(values.nro_documento) : 0,
            id_iglesia_dependiente: Number(values.id_iglesia_dependiente) != 0 ? Number(values.id_iglesia_dependiente) : null,
            cred_obligatoria: values.cred_obligatoria
        }

        setGrabandoDatosObrero(true)

        let mensaje_html = `<p>Los datos se grabaron exitosamente</p>`

        try {
            if (id_obrero) {
                resultado = await Axios.put(`/api/tablasgenerales/obrero/${id_obrero}`, objetoAgrabar)
                id_obrero_interno = id_obrero; // es el id del id_obrero a modificar
            } else {
                resultado = await Axios.post(`/api/tablasgenerales/obrero`, objetoAgrabar)
                id_obrero_interno = resultado.data.id_obrero; // es el id del nuevo obrero 
                mensaje_html = `<p>Los datos se grabaron exitosamente</p><p>(Nuevo ministro #${resultado.data.id_obrero})</p>`
            }

            Swal.fire({
                html: mensaje_html,
                icon: 'success',
                confirmButtonColor: '#3085d6',
            })

            setGrabandoDatosObrero(false)

            if (esModal) {
                if (id_obrero) { // si es modal y es una modificación
                    setContadorModificaciones(contadorModificaciones + 1)
                    finalizarAltaOcopia(false)
                } else { // si es modal y es un alta
                    finalizarAltaOcopia(true, id_obrero_interno)
                }

            } else { // si no es modal
                finalizarAltaOcopia(true); // es una función que se ejecuta en el padre para ejecutar una acción luego de haber creado o copiado un curso
            }

        } catch (err) {
            console.log(err.response)
            let mensaje_html_error;

            if (err.response.data.message) {
                mensaje_html_error = `<p>Se produjo un error al grabar los datos del ministro</p><p>${err.response.data.message}</p>`
            } else if (err.response.data) {
                mensaje_html_error = `<p>Se produjo un error al grabar los datos del ministro</p><p>${err.response.data}</p>`
            } else {
                mensaje_html_error = `<p>Se produjo un error al grabar los datos del ministro</p><p>${err.response}</p>`
            }


            Swal.fire({
                html: mensaje_html_error,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
            })

            setGrabandoDatosObrero(false)
        }
    }

    const seleccionarIglesia = (id_iglesia) => {
        setIglesiaSeleccionada(id_iglesia);
        toggle();
    }

    const cerrarModalIglesia = () => {
        setIglesiaSeleccionada(null)
        toggle()
    }

    const iniciarGrabarObrero = (values) => {
        let texto;
        let textoConfirmacion;

        if (id_obrero) {
            texto = `¿Está seguro de guardar los cambios del obrero
            ${id_obrero}?`
            textoConfirmacion = 'Si, modificar al obrero'
        } else {
            texto = `Confirma la creación del nuevo obrero? (${values.nombre})`
            textoConfirmacion = 'Si, crear el obrero'
        }

        Swal.fire({
            text: texto,
            showCancelButton: true,
            confirButtonText: textoConfirmacion,
            cancelButtonText: 'Cancelar'
        }).then(
            resultado => {
                if (resultado.value) {
                    grabarObrero(values);

                } else {
                    console.log("Se canceló la modificación o creación del obrero")
                }
            }
        )
    }


    // Se carga directamente al traer los datos del alumno
    /*const initialValuesAlumno = {
    
    } */

    // es un objeto cuyas propiedades deben coincidir con el nombre
    // de los Fields y con el nombre del validationSchema

    // algunas entidades comienzan de 1 y otras aceptan el valor 0 por eso
    // en algunos casos valido con .positive() para los que comienzan de 1, porque positive() excluye el cero
    // en otros valido con min(0) para los que comienzan de 0                              
    // el .test lo dejo como ejemplo para notar que se pueden hacer validaciones más específicas

    const validationSchemaObrero = Yup.object({

        nombre: Yup.string().max(100, 'El nombre debe tener como máximo 100 caracteres')
            .required('Falta completar el nombre y apellido'),
        conyuge: Yup.string().max(100, 'El conyuge debe tener como máximo 100 caracteres'),
        dia: Yup.number()
            .required('Falta seleccionar el día de nacimiento'),
        mes: Yup.number()
            .required('Falta seleccionar el mes de nacimiento'),
        anio: Yup.number()
            .min(1920, 'El año no es válido')
            .required('Falta seleccionar el año de nacimiento'),
        direccion: Yup.string().max(500, 'La dirección debe tener como máximo 500 caracteres'),
        localidad: Yup.string().max(500, 'La localidad debe tener como máximo 500 caracteres')
            .required('Falta completar la localidad'),
        cod_postal: Yup.string().max(10, 'El código postal debe tener como máximo 10 caracteres'),
        barrio: Yup.string().max(500, 'El barrio debe tener como máximo 500 caracteres'),
        telefono: Yup.string().max(500, 'El teléfono debe tener como máximo 500 caracteres'),
        celular: Yup.string().max(100, 'El número de celular debe tener como máximo 100 caracteres'),
        email: Yup.string().email('El email no es válido').max(100, 'El email debe tener como máximo 100 caracteres'),
        email_tesoreria: Yup.string().email('El email de tesoreria no es válido').max(100, 'El email de tesoreria debe tener como máximo 100 caracteres'),
        email_secretaria: Yup.string().email('El email de secretaria no es válido').max(100, 'El email de secretaria debe tener como máximo 100 caracteres'),
        email_pastor: Yup.string().email('El email no es válido').max(100, 'El email debe tener como máximo 100 caracteres'),
        oficio: Yup.string().max(100, 'El oficio debe tener como máximo 100 caracteres'),
        desc_ministerio: Yup.string().max(200, 'La descripción del ministerio debe tener como máximo 200 caracteres'),
        nombre_pst_resp: Yup.string().max(300, 'El nombre del pastor responsable debe tener como máximo 300 caracteres'),
        contacto_pst_resp: Yup.string().max(500, 'Los datos de contacto del pastor responsable deben tener como máximo 500 caracteres'),
        nombre_igl_resp: Yup.string().max(300, 'El nombre de la iglesia responsable debe tener como máximo 300 caracteres'),
        contacto_igl_resp: Yup.string().max(500, 'Los datos de contacto de la iglesia responsable deben tener como máximo 500 caracteres'),
        pastor: Yup.boolean().required(),
        maestro: Yup.boolean().required(),
        evangelista: Yup.boolean().required(),
        misionero: Yup.boolean().required(),
        otro: Yup.boolean().required(),
//        id_region: Yup.number().integer().required(),
        id_region: Yup.number().integer().required().test("nocero", "La región no es válida", value => value > 0),
        //id_rango: Yup.number().integer().required(),
        id_rango: Yup.number().integer().required().test("nocero", "El rango no es válido", value => value > 0),
        id_estado_civil: Yup.number()
            .integer()
            .required('Falta seleccionar el estado civil')
            .test("prueba", "El estado civil del ministro debe ser mayor a o igual a cero", value => value >= 0),
        id_provincia: Yup.number()
            .integer()
            .required('Falta seleccionar la provincia'),
        nro_documento: Yup.number().typeError('El documento debe ser un número').min(1000000, 'El documento debe tener como mínimo 7 dígitos')
            .max(99999999, 'El documento debe tener como máximo 8 dígitos').required('El número de documento es un dato requerido'),
        id_tipo_doc: Yup.number('El documento debe ser un número')
            .integer()
            .required('Falta seleccionar el tipo de documento').test("nocero", "El tipo de documento no es válido", value => value > 0),
        nombre_pastor: Yup.string().max(200, 'El nombre del pastor debe tener como máximo 200 caracteres'),
        id_iglesia_dependiente: Yup.number()
            .integer()
            .required('Falta seleccionar la iglesia o ministerio dependiente'),
        cred_obligatoria: Yup.boolean().required(),
          observaciones: Yup.string()
        .max(500, 'Las observaciones deben tener como máximo 500 caracteres'),        
    })

    const onsubmitObrero = values => {
        console.log(values)
        iniciarGrabarObrero(values)
    }

    const finalizarSeleccionProvincia = (obrero, objetoModificacion) => {

        objetoModificacion.funcion(objetoModificacion.id, obrero.id_provincia)


        setBuscarProvincias(false)
        toggle()


    }

    const sexoOptions = [
        {
            id: 1,
            value: 'M',
            nombre: 'Hombre'
        },
         {
            id: 2,
            value: 'F',
            nombre: 'Mujer'
        }
    ]

    if (huboError) {
        return <Main center><span>Se produjo un error al cargar los datos para esta vista</span></Main>
    }

    if (cargandoDatosTablasGenerales) {
        return <Main center>
            <div className='flex flex-col justify-center items-center mt-20'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando cargando datos generales...</span>
            </div>
        </Main>
    };

    if (cargandoDatosObrero) {
        return <Main center>
            <div className='flex flex-col justify-center items-center mt-20'>
                <Spinner className="h-12 w-12" />
                <span className="cargando font-semibold text-[15px]">Cargando datos personales del ministro...</span>
            </div>
        </Main>
    };

    return (
        <Main>
            {grabandoDatosObrero && <Main><div className='flex flex-col justify-center items-center mt-20'><Spinner className="h-12 w-12" /><span className="cargando text-white">Grabando datos...</span></div></Main>}

            {isShowing && iglesiaSeleccionada && <Modal hide={toggle} isShowing={isShowing} estilo={esCelular ? { width: 'auto' } : { width: '1000px' }} estiloWrapper={{ background: 'transparent' }} closeOnclickOutside={true}>
                <AbmIglesias id_iglesia={iglesiaSeleccionada} usuario={usuario} finalizarAltaOcopia={cerrarModalIglesia} esVisualizacion={true} />
            </Modal>}

            <div className={grabandoDatosObrero ? "hidden" : `mx-auto mt-[-20px] w-full max-w-[95%] xl:max-w-[1400px] h-auto rounded flex flex-col lg:flex-row items-start justify-center pt-3 ${esCelular ? 'px-2' : 'px-4'}`} >
                <div className="flex w-full justify-center">
                    <div className="w-full">
                        {/*el botòn de cancelar solo lo habilito cuando es un alta o copia*/}
                        {!esModal && <button type="button" onClick={() => finalizarAltaOcopia(false)} title={tituloCerrar} className="absolute botonAbm"><FontAwesomeIcon icon={faWindowClose} /></button>}
                        <Formik validateOnMount
                            enableReinitialize initialValues={objetoInicializacion}
                            validationSchema={validationSchemaObrero} onSubmit={onsubmitObrero}>
                            {({ values, errors, touched, handleChange, setFieldValue, resetForm, initialValues, dirty }) => {
                                return (
                                    <Form id="ref-ficha">
                                        {isShowing && buscarProvincias && <Modal hide={toggle} isShowing={isShowing} estilo={esCelular ? { width: 'auto' } : { width: '700px' }} estiloWrapper={{ background: 'transparent' }}>
                                            <BusquedaProvincias finalizarSeleccion={finalizarSeleccionProvincia} objetoModificacion={{ funcion: setFieldValue, id: 'id_provincia', nombre: 'nombre_encargado' }} />
                                        </Modal>}

                                        <div className="flex f-row items-center justify-between mb-4 bg-white p-3 rounded-lg shadow-sm border border-gray-100">
                                            <div className="flex items-center space-x-2">
                                                <GoBack titulo="" callback={finalizarObreroSeleccionado} onClick={() => resetForm(initialValues)}/>
                                                <Typography
                                                    variant="h6"
                                                    color="blue-gray"
                                                    className="font-medium mt-1 hover:text-blue-600 transition-colors"
                                                >
                                                    Volver a tabla de Ministros
                                                </Typography>
                                            </div>
                                            <div className="flex items-center space-x-3">
                                            </div>
                                        </div>

                                        <div className="mb-2">
                                            <div className="flex f-row">
                                                <Typography
                                                    variant="h5"
                                                    color="blue-gray"
                                                    className="font-medium mt-4"
                                                >
                                                    {tituloAbm}
                                                </Typography>
                                            </div>
                                            {values?.observaciones?.length >0 && <p className='cursor-pointer text-sm text-red-400' onClick={()=>hacerScroll('abm-observaciones')} title={values?.observaciones}>Revise el campo observaciones</p>}
                                        </div>

                                        <div className="flex flex-col md:flex-row mt-4 gap-4 items-center mb-0 bg-white p-4 rounded-md shadow-sm border border-blue-gray-50/50">
                                            <div className="flex flex-col w-full md:flex-1">
                                                <Typography variant="small" color="blue-gray" className="mb-1 font-semibold text-gray-500 uppercase tracking-widest text-[11px]">
                                                    Nombre del obrero
                                                </Typography>
                                                <Field
                                                    id="abm-nombre"
                                                    type="text"
                                                    autoComplete="off"
                                                    maxLength="100"
                                                    name="nombre"
                                                    onFocus={() => seleccionarTextoInput("abm-nombre")}
                                                    onClick={() => seleccionarTextoInput("abm-nombre")}
                                                    className={`input-ui-data !text-2xl !font-bold ${values.nombre ? 'input-cvalor' : 'input-vacio'}`}
                                                />
                                                <div className="error_formulario"><ErrorMessage name="nombre" /></div>
                                            </div>
                                            
                                            {/* Top actions/icons container simulating the 2 top avatars in the mockup */}
                                            <div className="flex flex-row ml-4 items-center gap-2 shrink-0 opacity-80 mt-1 pb-1">
                                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-green-500"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-blue-500"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle></svg>
                                            </div>
                                        </div>

                                        <div className="flex flex-col w-full">
                                            <Tabs value={activeTab} className="max-w-full mt-4 bg-transparent border-none w-full">
                                                <div className="overflow-x-auto w-full overflow-y-hidden pb-2 mx-1 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                                                    <TabsHeader
                                                        className="bg-blue-gray-50/70 p-1.5 flex-nowrap min-w-max border border-blue-gray-100/50 shadow-sm"
                                                        indicatorProps={{
                                                            className: "bg-gradient-to-tr from-blue-600 to-blue-500 shadow-md !text-white rounded-md",
                                                        }}
                                                    >
                                                        <Tab value="personal_ministerial" onClick={() => setActiveTab('personal_ministerial')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'personal_ministerial' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>
                                                            Personal y Ministerial
                                                        </Tab>
                                                        <Tab value="actas" onClick={() => setActiveTab('actas')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'actas' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>
                                                            Actas
                                                        </Tab>
                                                        <Tab value="datos_contacto" onClick={() => setActiveTab('datos_contacto')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'datos_contacto' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>
                                                            Datos de Contacto
                                                        </Tab>
                                                        <Tab value="rodados" onClick={() => setActiveTab('rodados')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'rodados' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>
                                                            Rodados
                                                        </Tab>
                                                        <Tab value="escrituras" onClick={() => setActiveTab('escrituras')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'escrituras' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>
                                                            Escrituras
                                                        </Tab>
                                                        <Tab value="iglesias_tramites" onClick={() => setActiveTab('iglesias_tramites')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'iglesias_tramites' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>
                                                            Iglesias y trámites
                                                        </Tab>
                                                        <Tab value="varios" onClick={() => setActiveTab('varios')} className={`px-2 py-1 hover:bg-gray-200 hover:text-black hover:rounded-lg text-xs md:text-sm font-semibold transition-all ${activeTab === 'varios' ? '!text-white hover:bg-transparent' : 'text-blue-gray-600'}`}>
                                                            Varios
                                                        </Tab>
                                                    </TabsHeader>
                                                </div>
                                                <TabsBody>
                                                    <TabPanel value="personal_ministerial">
                                                        <div className="bg-white p-5 rounded-md mb-4 relative grid grid-cols-1 lg:grid-cols-12 gap-8">
                                                            <div className="lg:col-span-9 flex flex-col gap-5">
                                                                <div className="grid grid-cols-1 md:grid-cols-12 gap-x-4 gap-y-5">
                                                                    
                                                                    <div className="col-span-12 md:col-span-5 flex flex-col select-ui-data">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Fecha de nacimiento</Typography>
                                                                        <div className="flex flex-row space-x-2">
                                                                            <select onChange={handleChange} value={values.dia} name='dia' className="select-bg-ui w-1/3">
                                                                                {vectorDias.map(item => <option value={item} key={item}>{item}</option>)}
                                                                            </select>
                                                                            <select onChange={handleChange} value={values.mes} name='mes' className="select-bg-ui w-1/3">
                                                                                {vectorMeses.map(item => <option value={item.id} key={item.id}>{item.mes}</option>)}
                                                                            </select>
                                                                            <select onChange={handleChange} value={values.anio} name='anio' className="select-bg-ui w-1/3">
                                                                                {vectorAnios.map(item => <option disabled={item == 1900} value={item} key={item}>{item}</option>)}
                                                                            </select>
                                                                        </div>
                                                                        <div className="error_formulario flex gap-4 mt-1"><ErrorMessage name="dia" /><ErrorMessage name="mes" /><ErrorMessage name="anio" /></div>
                                                                    </div>

                                                                    <div className="col-span-12 md:col-span-3 flex flex-col">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Edad actual</Typography>
                                                                        <input disabled value={values.anio === 1900 ? 'N/A' : `${new Date().getFullYear() - values.anio} años`} className="input-ui-data bg-blue-gray-50/50 text-gray-600 font-semibold" />
                                                                    </div>

                                                                    <div className="col-span-12 md:col-span-4 flex flex-col">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Sexo</Typography>
                                                                        <div className="flex items-center gap-6 mt-2 ml-1">
                                                                            {sexoOptions.map((item) => (
                                                                                <label key={item.id} className="flex items-center gap-2 cursor-pointer">
                                                                                    <Field type="radio" value={item.value} name="sexo" className="w-4 h-4 cursor-pointer" />
                                                                                    <Typography variant="small" className="font-medium">{item.nombre}</Typography>
                                                                                </label>
                                                                            ))}
                                                                        </div>
                                                                        <ErrorMessage name="sexo" component="div" className="error_formulario" />
                                                                    </div>

                                                                    <div className="col-span-12 md:col-span-6 flex flex-col select-ui-data">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Estado civil</Typography>
                                                                        <select onChange={handleChange} value={values.id_estado_civil} name="id_estado_civil" className='select-bg-ui w-full'>
                                                                            {estadosCiviles.map(item => <option key={`abmestadocivil${item.id_estado_civil}`} value={item.id_estado_civil}>{item.nombre}</option>)}
                                                                        </select>
                                                                        <div className="error_formulario"><ErrorMessage name="id_estado_civil" /></div>
                                                                    </div>

                                                                    <div className="col-span-12 md:col-span-6 flex flex-col select-ui-data">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Nacionalidad</Typography>
                                                                        <select onChange={handleChange} value={values.id_nacionalidad} name="id_nacionalidad" className='select-bg-ui w-full'>
                                                                            {nacionalidades.map(item => <option key={`abmcurso-permiso${item.id_nacionalidad}`} value={item.id_nacionalidad}>{item.nombre}</option>)}
                                                                        </select>
                                                                        <div className="error_formulario"><ErrorMessage name="id_nacionalidad" /></div>
                                                                    </div>

                                                                    <div className="col-span-12 md:col-span-6 flex flex-col select-ui-data">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Tipo de Documento</Typography>
                                                                        <select onChange={handleChange} value={values.id_tipo_doc} name="id_tipo_doc" className='select-bg-ui w-full'>
                                                                            <option value="0">No asignado</option>
                                                                            {tiposDocumentos.map(item => <option key={`abmtipodoc${item.id_tipo_doc}`} value={item.id_tipo_doc}>{item.nombre}</option>)}
                                                                        </select>
                                                                        <div className="error_formulario"><ErrorMessage name="id_tipo_doc" /></div>
                                                                    </div>

                                                                    <div className="col-span-12 md:col-span-6 flex flex-col">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Número de documento</Typography>
                                                                        <Field id="abm-nro_documento" type="text" autoComplete="off" maxLength="8" name="nro_documento" onFocus={() => seleccionarTextoInput("abm-nro_documento")} onClick={() => seleccionarTextoInput("abm-nro_documento")} className={`input-ui-data w-full ${values.nro_documento ? 'input-cvalor' : 'input-vacio'}`} />
                                                                        <div className="error_formulario"><ErrorMessage name="nro_documento" /></div>
                                                                    </div>

                                                                    <div className="col-span-12 flex flex-col">
                                                                        <div className="flex justify-between items-center mb-1">
                                                                            <Typography variant="small" color="blue-gray" className="font-medium text-xs uppercase tracking-wider text-gray-500">Cónyuge</Typography>
                                                                            <label className="flex items-center gap-2 cursor-pointer group">
                                                                                <Field type="checkbox" name="externo" className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500" />
                                                                                <span className="text-[11px] text-gray-500 font-medium group-hover:text-blue-600 transition-colors uppercase tracking-wider">No es obrero de la UAD</span>
                                                                            </label>
                                                                        </div>
                                                                        <Field id="abm-conyuge" type="text" autoComplete="off" maxLength="100" name="conyuge" placeholder="Nombre completo del cónyuge" className={`input-ui-data w-full ${values.conyuge ? 'input-cvalor' : 'input-vacio'}`} />
                                                                        <div className="error_formulario"><ErrorMessage name="conyuge" /></div>
                                                                    </div>

                                                                    <div className="col-span-12 flex flex-col">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Oficio</Typography>
                                                                        <Field id="abm-oficio" type="text" autoComplete="off" maxLength="100" name="oficio" placeholder="Describa el oficio" className={`input-ui-data w-full ${values.oficio ? 'input-cvalor' : 'input-vacio'}`} />
                                                                        <div className="error_formulario"><ErrorMessage name="oficio" /></div>
                                                                    </div>

                                                                    <div className="col-span-12 md:col-span-4 flex flex-col select-ui-data">
<Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Rango</Typography>
                                                                        <select disabled={id_obrero} onChange={handleChange} value={values.id_rango} name="id_rango" className="select-bg-ui w-full">
                                                                            {rangos.map(item => <option key={`abmrango${item.id_rango}`} value={item.id_rango}>{item.nombre}</option>)}
                                                                        </select>
                                                                        <div className="error_formulario"><ErrorMessage name="id_rango" /></div>
                                                                    </div>

                                                                    <div className="col-span-12 md:col-span-6 flex flex-col select-ui-data">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Región</Typography>
                                                                        <select disabled={id_obrero} onChange={(e) => { handleChange(e); setFieldValue('id_distrito', ''); }} value={values.id_region} name="id_region" className="select-bg-ui w-full">
                                                                            {regiones.map(item => <option key={`abmregion${item.id_region}`} value={item.id_region}>{item.nombre}</option>)}
                                                                        </select>
                                                                        <div className="error_formulario"><ErrorMessage name="id_region" /></div>
                                                                    </div>
                                                                </div>

                                                                <div className="grid grid-cols-1 md:grid-cols-12 gap-x-4 gap-y-2 mt-2">
                                                                    <div className="col-span-12 md:col-span-4 flex flex-col">
                                                                        <Typography variant="small" color="blue-gray" className="mb-3 font-medium text-xs uppercase tracking-wider text-gray-500">Ministerio desarrollado</Typography>
                                                                        <div className="grid grid-cols-2 gap-y-3 gap-x-2">
                                                                            <label className="flex items-center gap-2 cursor-pointer group"><Field type="checkbox" name="pastor" className="w-4 h-4 rounded border-gray-300 group-hover:border-blue-500" /> <span className="text-sm font-medium text-gray-700">Pastor</span></label>
                                                                            <label className="flex items-center gap-2 cursor-pointer group"><Field type="checkbox" name="evangelista" className="w-4 h-4 rounded border-gray-300 group-hover:border-blue-500" /> <span className="text-sm font-medium text-gray-700">Evangelista</span></label>
                                                                            <label className="flex items-center gap-2 cursor-pointer group"><Field type="checkbox" name="maestro" className="w-4 h-4 rounded border-gray-300 group-hover:border-blue-500" /> <span className="text-sm font-medium text-gray-700">Maestro</span></label>
                                                                            <label className="flex items-center gap-2 cursor-pointer group"><Field type="checkbox" name="misionero" className="w-4 h-4 rounded border-gray-300 group-hover:border-blue-500" /> <span className="text-sm font-medium text-gray-700">Misionero</span></label>
                                                                            <label className="flex items-center gap-2 cursor-pointer group"><Field type="checkbox" name="otro" className="w-4 h-4 rounded border-gray-300 group-hover:border-blue-500" /> <span className="text-sm font-medium text-gray-700">Otro</span></label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-span-12 md:col-span-8 flex flex-col mt-4 md:mt-0">
                                                                        <Typography variant="small" color="blue-gray" className="mb-1 font-medium text-xs uppercase tracking-wider text-gray-500">Descripción de ministerio</Typography>
                                                                        <Field name="desc_ministerio" type="text" maxLength="200" rows="3" component="textarea" className={`input-ui-data w-full h-[116px] resize-none ${values.desc_ministerio ? 'input-cvalor' : 'input-vacio'}`} />
                                                                        <div className="error_formulario"><ErrorMessage name="desc_ministerio" /></div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="lg:col-span-3 flex flex-col gap-6">
                                                                <div className='flex flex-col w-full'>
                                                                    <Typography variant="small" color="blue-gray" className="mb-2 font-medium text-xs uppercase tracking-wider text-gray-500 text-center">Fotografía</Typography>
                                                                    <div className="border border-dashed border-gray-300 rounded-lg flex flex-col justify-center items-center p-4 bg-gray-50/30 hover:bg-gray-50 transition-colors shadow-sm">
                                                                        {!foto4x4 ? (
                                                                            foto ? (
                                                                                <a href={`data:image/jpeg;base64,${foto}`} download={`${values.nro_documento}.jpg`} title="Clic para descargar foto" className="flex flex-col items-center group w-full">
                                                                                    <div className="overflow-hidden rounded-md shadow-sm border border-gray-200">
                                                                                        <img className="w-full object-cover cursor-pointer group-hover:scale-105 transition-transform duration-300" alt="Foto" src={`data:image/jpeg;base64,${foto}`} />
                                                                                    </div>
                                                                                    <p className='text-[11px] font-medium text-blue-500 mt-3 uppercase tracking-wider group-hover:text-blue-700 transition-colors'>Descargar Foto</p>
                                                                                </a>
                                                                            ) : (
                                                                                <div className="flex flex-col justify-center items-center p-8 opacity-50">
                                                                                    <img className="w-24 h-24 mb-3" alt="No posee foto" src={'images/user-circle.svg'} />
                                                                                    <span className="text-xs font-semibold text-gray-500 uppercase tracking-widest">Sin foto</span>
                                                                                </div>
                                                                            )
                                                                        ) : (
                                                                            <a href={foto4x4} download={`${values.nro_documento}.jpg`} title="Descargar foto" className="flex flex-col items-center group w-full">
                                                                                <div className="overflow-hidden rounded-md shadow-sm border border-gray-200">
                                                                                    <img className="w-full object-cover cursor-pointer group-hover:scale-105 transition-transform duration-300" src={foto4x4} alt="Foto 4x4" />
                                                                                </div>
                                                                                <p className='text-[11px] font-medium text-blue-500 mt-3 uppercase tracking-wider group-hover:text-blue-700 transition-colors'>Descargar Foto 4x4</p>
                                                                                {foto && <span className='text-[10px] text-gray-400 mt-1 text-center font-medium bg-gray-100 px-2 py-1 rounded-full'>Posee 2 fotos</span>}
                                                                            </a>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div className="w-full">
                                                                </div>
                                                            </div>
                                                        </div>
                                                </TabPanel>
                                                <TabPanel value="actas">
                                                    <TabActas id_obrero={id_obrero} esVisualizacion={false} />
                                                </TabPanel>
                                                <TabPanel value="datos_contacto">
                                                    <TabDatosContacto 
                                                        values={values} 
                                                        handleChange={handleChange} 
                                                        setFieldValue={setFieldValue}
                                                        provincias={provincias} 
                                                        setBuscarProvincias={setBuscarProvincias}
                                                        id_obrero={id_obrero}
                                                        toggleModalProvincia={toggle}
                                                    />
                                                </TabPanel>
                                                <TabPanel value="rodados">
                                                    <TabRodados id_obrero={id_obrero} esVisualizacion={false} />
                                                </TabPanel>
                                                <TabPanel value="escrituras">
                                                    <TabEscrituras id_obrero={id_obrero} esVisualizacion={false} />
                                                </TabPanel>
                                                <TabPanel value="iglesias_tramites" className="p-0 sm:p-2 lg:p-4">
                                                    <div className="bg-white p-3 md:p-5 rounded-md mb-4 mt-2">
                                                        {id_obrero ? (
                                                            <div className="mt-2 md:mt-4 pt-4">
                                                                {/* <ListadoIglesiasyOtrosDatos iglesias={iglesias} diezmosPersonales = {diezmosPersonales} seleccionarIglesia={seleccionarIglesia} id_obrero={id_obrero} esCelular={esCelular} /> */}
                                                                <ListadoIglesiasyOtrosDatos iglesias={iglesias} diezmosPersonales = {diezmosPersonales} seleccionarIglesia={seleccionarIglesia} id_obrero={id_obrero} esCelular={esCelular} /> {/* agregado por px el 17/08/2026 */}
                                                            </div>
                                                        ) : (
                                                            <div className="py-10 text-center text-gray-400 text-sm italic">
                                                                Las iglesias vinculadas y los trámites del ministro se mostrarán una vez creado. Guardá el ministro para verlos.
                                                            </div>
                                                        )}
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value="varios" className="p-0 sm:p-2 lg:p-4">
                                                    <div className="bg-white p-4 md:p-6 rounded-md mb-4 mt-2 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 border border-gray-100 shadow-sm relative">
                                                        {/* Fila 1: Código Seguridad y Credencial */}
                                                        <div className="col-span-12 md:col-span-4 flex flex-col">
                                                            <Typography variant="small" color="blue-gray" className="mb-2 font-medium text-xs uppercase tracking-wider text-gray-500">Código de seguridad web</Typography>
                                                            <div className="flex flex-1 items-center justify-center p-4 bg-gray-50/50 border border-gray-200 rounded-md shadow-inner min-h-[80px]">
                                                                <CodSeguridad values={values} id_obrero={id_obrero}/>
                                                            </div>
                                                        </div>
                                                        <div className="col-span-12 md:col-span-4 flex flex-col">
                                    <Typography variant="small" color="blue-gray" className="mb-2 font-medium text-xs uppercase tracking-wider text-gray-500">Otras opciones</Typography>
                                    <div className="flex flex-1 items-center p-4 bg-gray-50/40 border border-gray-200 rounded-md hover:bg-gray-100 transition-colors min-h-[80px]">
                                        <label title="Entidad Externa" className="flex items-center gap-4 cursor-pointer w-full">
                                            <Field type="checkbox" name="externo" className="w-5 h-5 rounded text-blue-600 focus:ring-blue-500 border-gray-300 shadow-sm" />
                                            <div className="flex flex-col">
                                                <span className="text-sm font-semibold text-gray-700">Entidad externa</span>
                                                <span className="text-xs text-gray-500">El ministro pertenece a una entidad externa (no es obrero de la UAD)</span>
                                            </div>
                                        </label>
                                    </div>
                                </div>

                                <div className="col-span-12 md:col-span-4 flex flex-col">{usuario.sede_admin && id_obrero ? (
                                                                <>
                                                                    <Typography variant="small" color="blue-gray" className="mb-2 font-medium text-xs uppercase tracking-wider text-gray-500">Configuración de Credencial</Typography>
                                                                    <div className="flex flex-1 items-center p-4 bg-blue-50/40 border border-blue-100 rounded-md hover:bg-blue-50/60 transition-colors min-h-[80px]">
                                                                        <label title="Forzar credencial activa" className="flex items-center gap-4 cursor-pointer w-full">
                                                                            <Field type="checkbox" name="cred_obligatoria" className="w-5 h-5 rounded text-blue-600 focus:ring-blue-500 border-gray-300 shadow-sm" />
                                                                            <div className="flex flex-col">
                                                                                <span className="text-sm font-semibold text-blue-900">Habilitar credencial</span>
                                                                                <span className="text-xs text-blue-700 opacity-80">(Forzar credencial activa)</span>
                                                                            </div>
                                                                        </label>
                                                                        <div className="error_formulario"><ErrorMessage name="cred_obligatoria" /></div>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="h-full w-full"></div>
                                                            )}
                                                        </div>

                                                        {/* Fila 2: Pastor Responsable */}
                                                        <div className="col-span-12 flex flex-col mt-2">
                                                            <Typography variant="small" color="blue-gray" className="mb-2 font-medium text-xs uppercase tracking-wider text-gray-500">Nombre del pastor responsable</Typography>
                                                            <Field name="nombre_pastor" type="text" maxLength="200" disabled={values.nombre_pastor.includes('Error')} placeholder="Escriba el nombre del pastor, la iglesia o el ministerio dependiente" autoComplete="off" onKeyDown={(e) => escapeListaP(e, values, { funcion: setFieldValue, id: 'id_iglesia_dependiente', nombre: 'nombre_pastor' })} onInput={(e) => BusquedaPastor(e, setFieldValue)} className={`input-ui-data w-full !bg-gray-50/50 ${values.nombre_pastor ? values.nombre_pastor.includes('Error') ? 'color-red blink' : 'input-cvalor' : 'input-vacio'}`} />
                                                            
                                                            {/* Contenedor relativo para los resultados de la búsqueda y boton desvincular juntos */}
                                                            <div className="w-full relative mt-2 flex justify-end">
                                                                {values.id_iglesia_dependiente != 0 && !values.nombre_pastor.includes('Error') && (
                                                                    <span title={`Desvincular de ${values.nombre_pastor}`} onClick={() => desvincularMinistro({ funcion: setFieldValue, id: 'id_iglesia_dependiente', nombre: 'nombre_pastor' })} className="cursor-pointer inline-flex items-center gap-1.5 text-[11px] font-semibold text-red-500 hover:text-red-700 bg-red-50/80 hover:bg-red-100 border border-red-100 px-3 py-1.5 rounded-md transition-all duration-200 shadow-sm">
                                                                        <FontAwesomeIcon icon={faUnlink} /> BORRAR VÍNCULO
                                                                    </span>
                                                                )}
                                                                
                                                                {buscarPastorUad && values.nombre_pastor.trim() != '' && (
                                                                    <div className="absolute top-0 left-0 w-full md:w-3/4 border border-blue-gray-100 rounded-md bg-white p-2 shadow-lg z-20">
                                                                        <span title="Cerrar búsqueda" onClick={() => cerrarBusquedaPastor({ funcion: setFieldValue, id: 'id_iglesia_dependiente', nombre: 'nombre_pastor' })} className="absolute top-2 right-2 cursor-pointer flex items-center justify-center bg-gray-200 text-gray-600 hover:bg-red-500 hover:text-white rounded-full w-6 h-6 transition-all shadow-sm z-10">
                                                                            <FontAwesomeIcon icon={faWindowClose} />
                                                                        </span>
                                                                        <BusquedaEntesdependientes texto={values.nombre_pastor} finalizarSeleccion={finalizarSeleccion} objetoModificacion={{ funcion: setFieldValue, id: 'id_iglesia_dependiente', nombre: 'nombre_pastor' }} />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>

                                                        {/* Fila 3: Observaciones */}
                                                        <div className="col-span-12 flex flex-col mt-2">
                                                            <Typography variant="small" color="blue-gray" className="mb-2 font-medium text-xs uppercase tracking-wider text-gray-500">Observaciones</Typography>
                                                            <Field as="textarea" name="observaciones" rows="4" placeholder="Ingrese detalles o notas adicionales..." className={`input-ui-data w-full p-4 border rounded-md shadow-sm !bg-gray-50/30 focus:!bg-white transition-colors ${values.observaciones ? 'input-cvalor' : 'input-vacio'}`} style={{ minHeight: '120px', resize: 'vertical' }} />
                                                            <div className="flex justify-end mt-1.5"><span className="text-xs text-gray-400 font-medium">{values.observaciones?.length || 0} / 500 caracteres</span></div>
                                                            <div className="error_formulario"><ErrorMessage name="observaciones" /></div>
                                                        </div>
                                                    </div>
                                                </TabPanel>
                                            </TabsBody>
                                        </Tabs>
                                        <div className="mt-8 pt-5 border-t border-gray-200 flex flex-row items-center justify-end space-x-4">
                                            {id_obrero && <> 
                                                {esActivo && usuario.perfil=='sede' && usuario.rol_sede > 96 && <Button 
                                                    type="button"
                                                    title='Eliminar el ministro' 
                                                    className="flex items-center px-8 py-2.5 shadow-md hover:shadow-lg text-sm bg-[#e01] text-white rounded-md"
                                                    onClick={eliminar}>
                                                            <TrashIcon width={20} strokeWidth={2} className="mr-2"/>
                                                            ELIMINAR
                                                </Button>}
                                            </>}
                                            {id_obrero && !esActivo && <Alert className="py-1 px-4" color="amber">Ministro Inactivo</Alert>}
                                            {id_obrero && esActivo && <ExportToExcelCredencial titulo="GENERAR CREDENCIAL" data={[datosParaImpresion]} color="teal" className="flex items-center px-8 py-2.5 shadow-md hover:shadow-lg text-sm bg-teal-500 hover:bg-teal-600 rounded-md" />}
                                            <Button variant="gradient" color="blue" className="flex items-center px-8 py-2.5 shadow-md hover:shadow-lg text-sm bg-blue-500 hover:bg-blue-600 rounded-md" type="submit"><CheckIcon className="w-5 h-5 mr-2" strokeWidth={2.5} /> GUARDAR</Button>
                                        </div>
                                    </div>
                                </Form>)
                            }}

                        </Formik>

                    </div>
                </div>
            </div>

        </Main>
    )
}

function hacerScroll(id) {
    let element = document.getElementById(id);

    if (!element) { return }
    element.scrollIntoView(false);
}

function cargarVectorDias(setDias) {
    var dia;
    var vectoDiasAux = [];

    for (var i = 1; i < 32; i++) {
        if (i < 10) {
            dia = `0${i}`;
        } else {
            dia = `${i}`;
        }
        vectoDiasAux.push(dia);
    }
    setDias(vectoDiasAux)
}

function cargarVectorMeses(setMeses) {
    var meses = [{ id: 1, mes: 'Enero' },
    { id: 2, mes: 'Febrero' },
    { id: 3, mes: 'Marzo' },
    { id: 4, mes: 'Abril' },
    { id: 5, mes: 'Mayo' },
    { id: 6, mes: 'Junio' },
    { id: 7, mes: 'Julio' },
    { id: 8, mes: 'Agosto' },
    { id: 9, mes: 'Septiembre' },
    { id: 10, mes: 'Octubre' },
    { id: 11, mes: 'Noviembre' },
    { id: 12, mes: 'Diciembre' }];
    setMeses(meses);
}

function anioNacimientoAlta() {
    let fecha_actual = new Date();
    let anio_hasta = Number(fecha_actual.getFullYear() - 10);

    return anio_hasta
}

function cargarVectorAnios(setAnios) {
    var anios = [];
    var anio;

    var fecha_actual = new Date();
    var anio_hasta = Number(fecha_actual.getFullYear() - 10);
    var anio_desde = anio_hasta - 80;

    for (var i = anio_hasta; i > anio_desde; i--) {
        anio = i.toString();
        anios.push(anio);
    }

    anios.push(1900); // agrego porque en la tabla hay fechas vacias que sql server los transforma a una fecha nula 1900-01-01 00:00:00.000
    // para que tome las fechas 1900-01-01 00:00:00.000 y que el usuario vea que es un año invalido 
    anios.push("")
    setAnios(anios);
}

function noNull(valor) {
    if (!valor) {
        return ''
    } else {
        return valor.trim()
    }
}

function noNullNumber(valor) {
    if (!valor) {
        return 0
    } else {
        return valor
    }
}

function filtrarRangoPermitidoParaAlta(usuario,rangos,setRangos) {

    if(usuario.sede_admin){
        return rangos.filter(i=>i.id_rango==0)[0]?.id_rango
    }else{
        return rangos[0]?.id_rango
    }
}

function filtrarRegionPermitidaParaAlta(regiones, setRegiones, id_region_usuario) {
    const regionesPermitidas = regiones.filter(item => item.id_region === id_region_usuario)

    if (regionesPermitidas.length > 0) {
        return regionesPermitidas[0].id_region
    } else {
        return regiones[0].id_region // pablo 26/06/2025
    }
}

function determinarFilas(palabra) {
    if (palabra.length > 69) {
        return 2
    } else {
        return 1
    }

}

function CondicionIglesia({ iglesia }) {
    return <div className="flex f-row jfc-fe text-smaller mt-2">
        <div className="ml-4"><span>Balances: </span>{iglesia.estado_balances == 1 && <span><FontAwesomeIcon className="color-green" icon={faCheckCircle} /> Al día</span>}
            {iglesia.estado_balances == 0 && <span><FontAwesomeIcon className="color-red" icon={faTimesCircle} /> Adeuda</span>}
        </div>
        <div className="ml-4"><span>Diezmos: </span> {iglesia.detalle_diezmos == 1 && <span><FontAwesomeIcon className="color-green" icon={faCheckCircle} /> Al día</span>}
            {iglesia.detalle_diezmos == 0 && <span><FontAwesomeIcon className="color-red" icon={faTimesCircle} /> Adeuda</span>}
        </div>
    </div>
}

function OtrasIglesiasObrero({ iglesias, seleccionarIglesia, buscandoDatos, huboError }) {
    return <div className="flex f-col">
        <Typography
            variant="h5"
            className="font-medium mt-4"
        >
            Otras iglesias: ({iglesias.length})
        </Typography>
        {buscandoDatos &&
            <div className='flex items-center gap-2 mt-3 text-sm text-gray-500'>
                <Spinner className="h-4 w-4" />
                <span>Buscando iglesias...</span>
            </div>
        }
        {!buscandoDatos && huboError &&
            <div className='mt-3'>
                <span className="text-sm text-red-500">Se produjo un error al cargar las otras iglesias.</span>
            </div>
        }
        {!buscandoDatos && !huboError && iglesias.length > 0 &&
            <div className='mt-2'>
                {iglesias.map(item => <div key={`otra-iglesia-${item.id_iglesia}`} className="diezmos mb-2"><span className="bg-blue-400 p-1 text-white rounded-md mr-1">{item.tipo_iglesia}</span><Button type="button" variant='text' className="p-2" onClick={() => seleccionarIglesia(item.id_iglesia)}>{item.iglesia}</Button><br />
                    <FontAwesomeIcon className="mt-2 mr-2" icon={faMapMarkerAlt} />
                    <span className="text-md whitespace-no-wrap">{item.provincia}</span></div>)}
            </div>
        }
        {!buscandoDatos && !huboError && iglesias.length == 0 &&
            <div className='mt-2 text-center'>
                <span className="text-center text-sm">Ninguna</span>
            </div>
        }
    </div>
}

function excluirIglesiasAutonomas(todas, autonomas) {

    const excluirAutonomas = todas.filter(item => !autonomas.some(iglesia => iglesia.id_iglesia == item.id_iglesia))

    return excluirAutonomas
}

function obtenerDescripcionPastor(entes, id) {
    let resultado = null;
    resultado = entes.filter(item => item.id == id).map(item => item.nombre)[0]

    if (resultado) {
        return resultado
    } else {
        return `Error. Vinculado a la iglesia ${id} pero no es ente dependiente`
    }
}

function obtenerAdjuntosDisponibles(adjuntos) {
    if (!adjuntos) {
        return []
    }

    return [
        { id: 'analitico', nombre: 'Analítico', url: adjuntos.analitico, titulo: 'Visualice el analítico de estudios teoloógicos' },
        { id: 'dni_frente', nombre: 'DNI Frente', url: adjuntos.dni_frente, titulo: 'Visualice el DNI Frente' },
        { id: 'dni_reverso', nombre: 'DNI Reverso', url: adjuntos.dni_reverso, titulo: 'Visualice el DNI Reverso' },
        { id: 'ant_penales', nombre: 'Ant. Penales', url: adjuntos.ant_penales, titulo: 'Visualice la constancia de antecedentes penales' },
        { id: 'cert_matrimonio', nombre: 'Cert. Matrimonio', url: adjuntos.cert_matrimonio, titulo: 'Visualice el certificado de matrimonio' }
    ].filter(item => item.url)
}

function normalizarIglesiaDashboard(item, origen) {
    return {
        id_iglesia: item.id_iglesia,
        nombre: item.nombre || item.iglesia || `Iglesia ${item.id_iglesia}`,
        tipo_iglesia: item.tipo_iglesia || (origen == 'autonoma' ? 'Autónoma' : 'Vinculada'),
        provincia: item.provincia || item.localidad || '',
        origen,
        estado_balances: item.estado_balances,
        detalle_diezmos: item.detalle_diezmos,
    }
}

function obtenerPrioridadIglesia(item) {
    const balanceAdeudado = item.estado_balances == 0
    const diezmoAdeudado = item.detalle_diezmos == 0

    if (balanceAdeudado && diezmoAdeudado) {
        return 3
    }

    if (balanceAdeudado || diezmoAdeudado) {
        return 2
    }

    if (item.origen == 'autonoma') {
        return 1
    }

    return 0
}

function DashboardMetricCard({ titulo, valor, subtitulo, tono = 'azul' }) {
    const clases = {
        azul: 'bg-blue-50 border-blue-200 text-blue-700',
        verde: 'bg-green-50 border-green-200 text-green-700',
        amber: 'bg-amber-50 border-amber-200 text-amber-700',
        rojo: 'bg-red-50 border-red-200 text-red-700',
        gris: 'bg-gray-50 border-gray-200 text-gray-700',
    }

    return <div className={`rounded-xl border p-4 shadow-sm ${clases[tono] || clases.azul}`}>
        <p className="text-xs uppercase tracking-[0.2em] font-semibold opacity-80">{titulo}</p>
        <p className="text-3xl font-bold mt-2">{valor}</p>
        <p className="text-sm mt-1 opacity-80">{subtitulo}</p>
    </div>
}

function DashboardIglesiasTramites({
    iglesias,
    otrasIglesias,
    adjuntosDisponibles,
    filtroDashboard,
    setFiltroDashboard,
    seleccionarIglesia,
    setDashboardIglesiaSeleccionada,
    buscandoDatos,
    errorOtrasIglesias,
    errorAdjuntos,
    id_obrero, // ps 17/08/2026
    diezmosPersonales=[] // ps 17/08/2026
}) {

    // ps 17/08/2026 excluimos iglesias que no tienen id_iglesia
    // const autonomasNormalizadas = iglesias.map(item => normalizarIglesiaDashboard(item, 'autonoma'))
    // const otrasNormalizadas = otrasIglesias.map(item => normalizarIglesiaDashboard(item, 'otras'))
    
    const autonomasNormalizadas = iglesias.filter(i=>!!i.id_iglesia).map(item => normalizarIglesiaDashboard(item, 'autonoma'))
    const otrasNormalizadas = otrasIglesias.filter(i=>!!i.id_iglesia).map(item => normalizarIglesiaDashboard(item, 'otras'))

    const iglesiasResumen = [...autonomasNormalizadas, ...otrasNormalizadas].sort((a, b) => {
        const prioridad = obtenerPrioridadIglesia(b) - obtenerPrioridadIglesia(a)
        if (prioridad != 0) {
            return prioridad
        }

        return a.nombre.localeCompare(b.nombre)
    })

    const iglesiasConAlertas = iglesiasResumen.filter(item => item.estado_balances == 0 || item.detalle_diezmos == 0)
    const balancesAdeudados = iglesiasResumen.filter(item => item.estado_balances == 0).length
    const diezmosAdeudados = iglesiasResumen.filter(item => item.detalle_diezmos == 0).length

    const filtros = [
        { id: 'todas', nombre: `Todas (${iglesiasResumen.length})` },
        { id: 'alertas', nombre: `Con alertas (${iglesiasConAlertas.length})` },
        { id: 'autonomas', nombre: `Autónomas (${autonomasNormalizadas.length})` },
        { id: 'otras', nombre: `Otras (${otrasNormalizadas.length})` },
    ]

    const iglesiasFiltradas = iglesiasResumen.filter(item => {
        if (filtroDashboard == 'alertas') {
            return item.estado_balances == 0 || item.detalle_diezmos == 0
        }
        if (filtroDashboard == 'autonomas') {
            return item.origen == 'autonoma'
        }
        if (filtroDashboard == 'otras') {
            return item.origen == 'otras'
        }

        return true
    })

    return <div className="rounded-2xl border border-blue-gray-100 bg-gradient-to-br from-slate-50 via-white to-blue-50 p-4 md:p-6 shadow-sm">
        <div className="flex flex-col gap-2 lg:flex-row lg:items-end lg:justify-between">
            <div>
                <Typography variant="h4" className="font-semibold text-blue-gray-700">
                    Dashboard de iglesias y trámites
                </Typography>
                <p className="text-sm text-gray-500 mt-1">
                    Resumen operativo de las iglesias vinculadas al ministro y acceso rápido al dashboard financiero por iglesia.
                </p>
            </div>
            {(errorOtrasIglesias || errorAdjuntos) &&
                <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700">
                    {errorOtrasIglesias && <p>El resumen de iglesias es parcial.</p>}
                    {errorAdjuntos && <p>No se pudieron cargar todos los adjuntos.</p>}
                </div>
            }
           {diezmosPersonales?.length > 0 && ( // agregado por PS el 17/08/2026
                <div 
                    onClick={() => {
                    document.getElementById('diezmos_personales')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 cursor-pointer hover:bg-amber-100 transition-colors duration-150 inline-block shadow-sm"
                >
                    <p className="flex items-center font-medium"> 
                    <span className="w-6 h-6 rounded-full bg-blue-600 text-white text-xs font-bold inline-flex items-center justify-center shadow-sm select-none mr-2">
                        $
                    </span> 
                    El ministro tiene aportes personales
                    </p>
                </div>
            )}  
        </div>

        <div className="grid grid-cols-1 gap-3 mt-4 md:grid-cols-2 xl:grid-cols-3">
            <DashboardMetricCard titulo="Iglesias vinculadas" valor={iglesiasResumen.length} subtitulo="Autónomas y otras iglesias asociadas" tono="azul" />
            <DashboardMetricCard titulo="Autónomas" valor={autonomasNormalizadas.length} subtitulo="Iglesias a cargo directo" tono="verde" />
            <DashboardMetricCard titulo="Otras iglesias" valor={otrasNormalizadas.length} subtitulo="Anexos o vinculaciones relacionadas" tono="gris" />
            <DashboardMetricCard titulo="Balances adeudados" valor={balancesAdeudados} subtitulo="Iglesias con estado pendiente" tono={balancesAdeudados > 0 ? 'rojo' : 'verde'} />
            <DashboardMetricCard titulo="Diezmos adeudados" valor={diezmosAdeudados} subtitulo="Iglesias con diezmos pendientes" tono={diezmosAdeudados > 0 ? 'amber' : 'verde'} />
            <DashboardMetricCard titulo="Adjuntos cargados" valor={adjuntosDisponibles.length} subtitulo="Documentación disponible en la ficha" tono="azul" />
        </div>

        <div className="mt-5 rounded-xl border border-blue-gray-100 bg-white p-4 shadow-sm">
            <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
                <div>
                    <Typography variant="h6" className="font-semibold text-blue-gray-700">
                        Archivos adjuntos
                    </Typography>
                    <p className="text-sm text-gray-500 mt-1">
                        Acceso rápido a la documentación cargada para este ministro.
                    </p>
                </div>
                <span className="inline-flex w-fit rounded-full bg-blue-50 px-3 py-1 text-sm font-semibold text-blue-700">
                    {adjuntosDisponibles.length} disponibles
                </span>
            </div>

            {adjuntosDisponibles.length == 0 &&
                <div className="mt-3 rounded-lg border border-dashed border-blue-gray-200 bg-blue-gray-50/40 px-4 py-3 text-sm text-gray-500">
                    No hay archivos adjuntos cargados.
                </div>
            }

            {adjuntosDisponibles.length > 0 &&
                <div className="mt-4 flex flex-wrap gap-2">
                    {adjuntosDisponibles.map(item => <button
                        key={`adjunto-dashboard-${item.id}`}
                        type="button"
                        title={item.titulo}
                        onClick={() => traerAbrirUrl(item.url)}
                        className="rounded-full border border-blue-200 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100"
                    >
                        {item.nombre}
                    </button>)}
                </div>
            }
        </div>

        <div className="mt-5">
            <div className="flex flex-wrap gap-2">
                {filtros.map(item => <button
                    key={`filtro-dashboard-${item.id}`}
                    type="button"
                    onClick={() => setFiltroDashboard(item.id)}
                    className={`rounded-full border px-3 py-1.5 text-sm font-semibold transition-colors ${filtroDashboard == item.id ? 'border-blue-600 bg-blue-600 text-white' : 'border-blue-gray-100 bg-white text-blue-gray-600 hover:border-blue-200 hover:text-blue-500'}`}
                >
                    {item.nombre}
                </button>)}
            </div>

            {buscandoDatos &&
                <div className="flex items-center gap-2 mt-4 text-sm text-gray-500">
                    <Spinner className="h-4 w-4" />
                    <span>Actualizando resumen de iglesias y adjuntos...</span>
                </div>
            }

            {!buscandoDatos && iglesiasFiltradas.length == 0 &&
                <div className="mt-4 rounded-xl border border-dashed border-blue-gray-200 bg-white p-4 text-sm text-gray-500">
                    No hay iglesias para el filtro seleccionado.
                </div>
            }

            {!buscandoDatos && iglesiasFiltradas.length > 0 &&
                <div className="grid grid-cols-1 gap-3 mt-4 xl:grid-cols-2">
                    {iglesiasFiltradas.map(item => {
                        const balanceAdeudado = item.estado_balances == 0
                        const diezmoAdeudado = item.detalle_diezmos == 0

                        return <div key={`dashboard-iglesia-${item.id_iglesia}`} className="rounded-xl border border-blue-gray-100 bg-white p-4 shadow-sm">
                            <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
                                <div>
                                    <div className="flex flex-wrap items-center gap-2">
                                        <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${item.origen == 'autonoma' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
                                            {item.origen == 'autonoma' ? 'Autónoma' : 'Otra iglesia'}
                                        </span>
                                        <span className="inline-flex rounded-full bg-blue-gray-50 px-2.5 py-1 text-xs font-semibold text-blue-gray-600">
                                            {item.tipo_iglesia}
                                        </span>
                                    </div>
                                    <p className="text-lg font-semibold text-blue-gray-700 mt-2">{item.nombre}</p>
                                    {item.provincia && <p className="text-sm text-gray-500 mt-1">{item.provincia}</p>}
                                </div>
                                <div className="flex flex-wrap gap-2">
                                    <button
                                        type="button"
                                        onClick={() => setDashboardIglesiaSeleccionada(item.id_iglesia)}
                                        className="rounded-lg border border-blue-200 bg-blue-50 px-3 py-2 text-sm font-semibold text-blue-600 hover:bg-blue-100"
                                    >
                                        Dashboard
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => seleccionarIglesia(item.id_iglesia)}
                                        className="rounded-lg border border-blue-gray-200 bg-white px-3 py-2 text-sm font-semibold text-blue-gray-700 hover:bg-blue-gray-50"
                                    >
                                        Ver ficha
                                    </button>
                                </div>
                            </div>

                            <div className="mt-4 flex flex-wrap gap-2 text-sm">
                                <span className={`rounded-full px-3 py-1 font-semibold ${balanceAdeudado ? 'bg-red-50 text-red-600' : 'bg-green-50 text-green-700'}`}>
                                    Balances: {item.estado_balances == null ? 'Sin dato' : balanceAdeudado ? 'Adeuda' : 'Al día'}
                                </span>
                                <span className={`rounded-full px-3 py-1 font-semibold ${diezmoAdeudado ? 'bg-amber-50 text-amber-700' : 'bg-green-50 text-green-700'}`}>
                                    Diezmos: {item.detalle_diezmos == null ? 'Sin dato' : diezmoAdeudado ? 'Adeuda' : 'Al día'}
                                </span>
                            </div>
                        </div>
                    })}
                </div>
            }

           {diezmosPersonales?.length > 0 && ( // agregado por PS el 17/8/2026
            <div id="diezmos_personales" className="w-full mt-4 p-4 bg-white rounded-xl border border-gray-200 shadow-sm">
                <BalancesYdiezmos 
                id_iglesia={0} 
                id_obrero={id_obrero} 
                mensajeCustomSinDatos="No se encontraron aportes personales"
                />
            </div>
            )}
        </div>
    </div>
}

function ListadoIglesiasyOtrosDatos({ iglesias, seleccionarIglesia, id_obrero, esCelular,
    diezmosPersonales // agregado por PS el 17/08/2026
}) {
    const [otrasIglesias, setOtrasIglesias] = useState([])
    const [adjuntos, setAdjuntos] = useState(null)
    const [buscandoDatos, setBuscandoDatos] = useState(false)
    const [filtroDashboard, setFiltroDashboard] = useState('todas')
    const [dashboardIglesiaSeleccionada, setDashboardIglesiaSeleccionada] = useState(null)
    const [errorOtrasIglesias, setErrorOtrasIglesias] = useState(null)
    const [errorAdjuntos, setErrorAdjuntos] = useState(null)

    useEffect(() => {
        let mounted = true

        const buscarDatosComplementarios = async () => {
            try {
                setBuscandoDatos(true)

                const [resultadoIglesias, resultadoAdjuntos] = await Promise.allSettled([
                    Axios.get(`/api/tablasgenerales/iglesiasobreroall/${id_obrero ? id_obrero : 0}`),
                    Axios.get(`/api/tablasgenerales/obrero/adjuntos/${id_obrero ? id_obrero : 0}`)
                ])

                if (!mounted) {
                    return
                }

                if (resultadoIglesias.status == 'fulfilled') {
                    setOtrasIglesias(excluirIglesiasAutonomas(resultadoIglesias.value.data, iglesias))
                    setErrorOtrasIglesias(null)
                } else {
                    setOtrasIglesias([])
                    setErrorOtrasIglesias(resultadoIglesias.reason?.response?.data?.message || resultadoIglesias.reason?.message || 'No se pudieron cargar las otras iglesias')
                }

                if (resultadoAdjuntos.status == 'fulfilled') {
                    setAdjuntos(resultadoAdjuntos.value.data)
                    setErrorAdjuntos(null)
                } else {
                    setAdjuntos(null)
                    setErrorAdjuntos(resultadoAdjuntos.reason?.response?.data?.message || resultadoAdjuntos.reason?.message || 'No se pudieron cargar los adjuntos')
                }
            } finally {
                if (mounted) {
                    setBuscandoDatos(false)
                }
            }
        }

        if (id_obrero) {
            buscarDatosComplementarios()
        }

        return () => { mounted = false }
    }, [id_obrero, iglesias])

    const adjuntosDisponibles = obtenerAdjuntosDisponibles(adjuntos)

    return <div className="flex flex-col gap-6">
        {Boolean(dashboardIglesiaSeleccionada) && <Modal
            hide={() => setDashboardIglesiaSeleccionada(null)}
            isShowing={Boolean(dashboardIglesiaSeleccionada)}
            estilo={esCelular ? { width: 'auto', maxWidth: '96vw' } : { width: '1120px', maxWidth: '96vw' }}
            estiloWrapper={{ background: 'transparent' }}
            closeOnclickOutside={true}
        >
            <DashboardFinanciero
                id_iglesia={dashboardIglesiaSeleccionada}
                id_obrero={id_obrero} // 14/08/2026 ps por tema diezmos personales                
                finalizar={() => setDashboardIglesiaSeleccionada(null)}
            />
        </Modal>}

        <DashboardIglesiasTramites
            id_obrero = {id_obrero} // 14/08/2026 ps por tema diezmos personales        
            iglesias={iglesias}
            otrasIglesias={otrasIglesias}
            adjuntosDisponibles={adjuntosDisponibles}
            filtroDashboard={filtroDashboard}
            setFiltroDashboard={setFiltroDashboard}
            seleccionarIglesia={seleccionarIglesia}
            setDashboardIglesiaSeleccionada={setDashboardIglesiaSeleccionada}
            buscandoDatos={buscandoDatos}
            errorOtrasIglesias={errorOtrasIglesias}
            errorAdjuntos={errorAdjuntos}
            diezmosPersonales={diezmosPersonales} // ps 17/08/2026
        />
    </div>
}

const setearRangosSegunCasos = (setRangos, vectorRangos, usuario, id_obrero) => {

    if (!id_obrero) //caso alta
    {
        setRangos(usuario.sede_admin ? vectorRangos : vectorRangos.filter(item => item.nombre.includes('sin credencial')));
    } else { //caso modificación
        setRangos(vectorRangos);
    }
}

const Adjuntos = ({ adjuntos, buscandoDatos, error }) => {
    if (error) {
        return <div>
            <p title={error} className='text-sm text-red-500 mt-2'>Hay errores al cargar los adjuntos</p>
        </div>
    }

    if (buscandoDatos && !adjuntos) {
        return <div className='flex items-center gap-2 mt-3 text-sm text-gray-500'>
            <Spinner className="h-4 w-4" />
            <span>Buscando adjuntos...</span>
        </div>
    }

    const adjuntosDisponibles = obtenerAdjuntosDisponibles(adjuntos)

    return <div>
        {adjuntosDisponibles.length == 0 && <p className='text-center text-sm mt-2'>Ninguno</p>}
        {adjuntosDisponibles.length > 0 && <div className='mt-2 space-y-1'>
            {adjuntosDisponibles.map(item => <p key={`adjunto-${item.id}`}><span title={item.titulo} className='cursor-pointer text-blue-400' onClick={() => traerAbrirUrl(item.url)}>{item.nombre}</span></p>)}
        </div>}
    </div>
}

const Actas = ({ id_obrero }) => {
    const [actas, setActas] = React.useState([]);
    const [error, setError] = React.useState(null);

    useEffect(() => {
        if(id_obrero) buscarActas(id_obrero);
    }, [])

    const buscarActas = async (id) => {
        try {
            const { data } = await Axios.get(`/api/tablasgenerales/obrero/actas/${id}`)
            setActas(data)
        } catch (err) {
            console.log('Error al buscar las actas del ministro', err)
            setError(err?.response?.data?.message || err?.message || JSON.stringify(err))
        }
    }

    if(!id_obrero){return null}

    if (error) {
        return <div>
            <p title={error}>Hay errores</p>
        </div>
    }

    if (actas.length == 0) {
        return <p className='text-center text-sm mt-2'>No se encontraron actas</p>
    }

    return (
    <div className="overflow-x-auto p-4">
        {/* border-collapse hace que los bordes de las celdas se unan en uno solo */}
        <table className="min-w-full border-collapse border border-gray-300 shadow-sm">
            <thead className="bg-gray-100">
                <tr>
                    <th className="border border-gray-300 p-2 text-sm font-semibold text-gray-700">Acta</th>
                    <th className="border border-gray-300 p-2 text-sm font-semibold text-gray-700">Fecha</th>
                    <th className="border border-gray-300 p-2 text-sm font-semibold text-gray-700">Tipo</th>
                    <th className="border border-gray-300 p-2 text-sm font-semibold text-gray-700 text-left">Observaciones</th>
                </tr>
            </thead>
            <tbody>
                {actas.map(item => (
                    <tr key={item.id_obrero_acta} className="hover:bg-gray-50 transition-colors">
                        <td className="border border-gray-300 p-2 text-sm text-center">{item.nro_acta}</td>
                        <td className="border border-gray-300 p-2 text-sm text-center">{item.fecha}</td>
                        <td className="border border-gray-300 p-2 text-sm text-center">
                            <span className="px-2 py-1 rounded-md bg-blue-50 text-blue-700 text-xs font-medium border border-blue-200">
                                {item.tipo}
                            </span>
                        </td>
                        <td 
                            title={item.observaciones} 
                            className="border border-gray-300 p-2 text-sm text-gray-600 max-w-xs overflow-hidden text-ellipsis whitespace-nowrap"
                        >
                            {item.observaciones}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);
   
    // return <div>
    //     <table>
    //         <thead>
    //             <tr>
    //                 <th>Acta</th>
    //                 <th>Fecha</th>
    //                 <th>Tipo</th>
    //                 <th className='text-left'>Observaciones</th>
    //             </tr>
    //         </thead>
    //         <tbody>
    //             {actas.map(item => {
    //                     return (
    //                     <tr key={item.id_obrero_acta} >
    //                         <td>{item.nro_acta}</td>
                            
    //                         <td>{item.fecha}</td>
                            
    //                         <td>
    //                             {item.tipo} 
    //                         </td>

    //                         <td 
    //                             title={item.observaciones} 
    //                             className="p-2 max-w-xs overflow-hidden text-ellipsis whitespace-nowrap text-sm text-gray-600"
    //                         >
    //                             {item.observaciones}
    //                         </td>
    //                     </tr>
    //                 );
    //             })
    //             }
    //         </tbody>
    //     </table>
    // </div>
}

const CodSeguridad = ({values,id_obrero})=>{
    const [copiado,setCopiado]=React.useState(false);
const buttonRef = useRef(null);

    const texto = `
Hola ${values.nombre}

Muy bienvenido a la UNION DE LAS ASAMBLEAS DE DIOS
Nos complace informale que su solicitud ha sido aprobada y que ya cuenta con las credenciales que le habilitan como ministro en nuestra asociación.

A continuación encontrará un link para acceder por primera vez a la plataforma web de ministros UAD

Le pediremos que elija un número de 4 dígitos como código de seguridad.

https://ministros.uad.digital/login/inicial/${values.id_tramite}

Una vez que haya gestionado su código de seguridad podrá utilizarlo para acceder en lo sucesivo a la aplicación de ministros UAD

Muchas bendiciones
    `
    const copiarLink = async (e)=>{
        e.preventDefault()

        try{
            const copy = await navigator.clipboard.writeText(texto);
            setCopiado(true);
            if (buttonRef.current) {
                buttonRef.current.blur();
            }
            setTimeout(() => {
                    setCopiado(false)
                }, 2000);
            }catch(err){
                alert(err)
        }
}

    // Ministro nuevo: todavía no tiene código de seguridad (se genera cuando ingresa por primera vez)
    if(!id_obrero){
        return <div className="flex flex-col items-center text-center">
                    <Typography variant="small" color="blue-gray" className="font-medium">
                        Cód. Seguridad
                    </Typography>
                    <span className="text-xs text-gray-400 mt-1">
                        Disponible una vez creado el ministro
                    </span>
                </div>
    }

    if(values.cod_seguridad!=-9999){
        return <div className="flex flex-col mt-2 lg:mt-0">

                    <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium text-center"
                    >
                        Cod. Seguridad
                    </Typography>
                    <span className="text-center mt-1">{values.cod_seguridad}</span>
                </div>
    }else{
        return <div>
             <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-medium text-center"
                    >
                        Cod. Seguridad
                    </Typography>
                <div>
                    {values?.id_tramite && <>
                    <IconButton     
                            ref={buttonRef}
                            title='Copie el link para pasarlo al ministro por whatsapp o e-mail' onClick={copiarLink}  aria-label="upload picture" >
                        <span className='color-red text-small mr-3'>Primer ingreso pendiente</span>
                        <ContentCopyIcon />
                    </IconButton>
                     {copiado && <div className='flex flex-col items-center'>
                            <p className='color-red text-small'>Link copiado </p>
                            <p>(Envíe por whatsapp o e-mail)</p>
                     </div>    }
                     </>} 
                     {!values?.id_tramite && <p className='text-small font-extrabold'>Contacte al equipo de sistemas indicando que el link de primer ingreso no está disponible (ID Ministro:{id_obrero})</p>}
                </div>

        </div>
    }
   
}